import { Tooltip } from 'antd'
import { BaseButton } from 'components/elements/BaseButton'
import { CallingStatusModal } from 'features/calls'
import { useGlobal } from 'raducer/global'
import { FC, useState } from 'react'

const LeadPhoneCallCell: FC<{
 leadId?: any
 leadName?: string
 number?: string
 className?: string
 leadTransfer?: boolean
}> = ({ leadId, leadName, number, className, leadTransfer }) => {
 const [showCall, setShowCall] = useState(false)
 const { global } = useGlobal()
 const showVoiceCallOption =
  global?.voice_enabled === true && leadTransfer !== false

 if (!number) return null

 return (
  <div className="d-flex align-items-center justify-content-between">
   <Tooltip title={`+1 ${number}`}>
    <span
     className={`text-truncate d-inline-block ${className || ''}`}
     style={{ maxWidth: '100%' }}
    >{`+1 ${number}`}</span>
   </Tooltip>
   {showVoiceCallOption && (
    <BaseButton
     buttonStyle="outline"
     buttonType="primary"
     size="small"
     icon={<i className="fas fa-phone-alt" />}
     tooltipText="Smart Call"
     onClick={(e) => {
      e?.stopPropagation()
      setShowCall(true)
     }}
    />
   )}
   {showCall && (
    <CallingStatusModal
     leadId={leadId}
     number={number}
     leadName={leadName}
     onClose={() => setShowCall(false)}
    />
   )}
  </div>
 )
}

export default LeadPhoneCallCell
